/**
 * Disable console.log in production while keeping error/warn for debugging
 */

const isProduction = process.env.NODE_ENV === 'production';

if (isProduction) {
  // Override console.log to do nothing in production
  console.log = () => {};
  
  // Keep console.warn and console.error for critical issues
  const originalWarn = console.warn;
  const originalError = console.error;
  
  console.warn = (...args: any[]) => {
    // Only show warnings that are likely important
    const message = args[0]?.toString() || '';
    if (message.includes('React') || message.includes('Warning') || message.includes('deprecated')) {
      originalWarn(...args);
    }
  };
  
  console.error = (...args: any[]) => {
    // Always show errors
    originalError(...args);
  };
}

// Export for manual control if needed
export const enableConsoleLogging = () => {
  if (isProduction) {
    // Re-enable console.log for debugging
    console.log = (...args: any[]) => {
      // Use original console if available
      (window as any).originalConsoleLog?.(...args) || 
      // Fallback to alert for critical debugging
      console.error('[DEBUG LOG]', ...args);
    };
  }
};

export const disableConsoleLogging = () => {
  if (isProduction) {
    console.log = () => {};
  }
};

// Store original console.log for debugging purposes
if (isProduction && !(window as any).originalConsoleLog) {
  (window as any).originalConsoleLog = console.log;
} 